import { appstr } from "../utils/appstr";
import {
  enumColorPickAdvMode,
  enumFillMode,
  enumKeyboardTargetEnterAction,
  enumPanelBorderStyle,
  enumShortCutModKeys,
  kAdvOptHeight,
  kAdvOptHeightLtd,
  kEnterOKShortCut
} from "../constants";
import { QPanel } from "./QPanel";
import { QRadioButtonGroup } from "./QRadioButtonGroup";
import { TPostColorPicker } from "../utils/TPostColorPicker";
import { AddStdButtonAutoPos } from "../utils/AddStdButtonAutoPos";

export class QAdvOptsPicker extends QPanel {
  constructor() {
    super();
    this.fWSMgr = null;
    this.fCellFillMode = null;
    this.fSrcPicker = null;
    this.fRadioGroup = null;
    this.fCmdCode = null;
    this.fStartFillMode = null;

    this.fColor1Selector = null;
    this.fColor2Selector = null;

    this.fStartColor = null;
    this.fStartColor2 = null;
    this.fNewColor = null;
    this.fNewColor2 = null;
    this.fBaseCmd = null;

    this.fOKBut = null;
  }

  MapFillModeToCmd(fillMode) {
    var theCmd;

    switch (fillMode) {
      case enumFillMode.solidFill:
        theCmd = "SolidFill";
        break;
      case enumFillMode.linearGradientDown:
        theCmd = "GradientFill";
        break;
      case enumFillMode.noFill:
        theCmd = "NoFill";
        break;
      case enumFillMode.dashline:
        theCmd = "DashLine";
        break;
      case enumFillMode.triangle:
        theCmd = "Triangle";
        break;
      case enumFillMode.lefttriangle:
        theCmd = "LeftTriangle";
        break;
      case enumFillMode.separator:
        theCmd = "Separator";
        break;
    }

    return theCmd;
  }

  InitAdvOptsPicker(
    wsMgr,
    theWidth,
    srcPicker,
    startFillMode,
    startColor,
    startColor2,
    baseCmd,
    advMode
  ) {
    this.fBaseCmd = baseCmd;
    this.fStartColor = startColor;
    this.fStartColor2 = startColor2;
    this.fNewColor = startColor;
    this.fNewColor2 = startColor2;

    this.fStartFillMode = startFillMode;
    this.fSrcPicker = srcPicker;
    this.fWSMgr = wsMgr;
    this.fUIColors = wsMgr.GetUIColors();

    if (srcPicker["parent"]) this["parent"] = srcPicker["parent"];

    var theHeight = advMode === enumColorPickAdvMode.full ? kAdvOptHeight : kAdvOptHeightLtd;
    this.SizePanel(theWidth, theHeight);
    this.SetModalOn(true);
    this.SetFillColor(this.fUIColors.GetSecondaryPanelFillColor());
    this.SetShadowOn(true);
    this.SetBorderStyle(enumPanelBorderStyle.singleBorder);
    this.SetNeedsCustomResize(true);

    var indent = 10;
    var yPos = 6;

    this.fCmdCode = this.MapFillModeToCmd(startFillMode);
    var kFillRadioGroup = [
      ["solidfill", "SolidFill"],
      ["gradientfill", "GradientFill"],
      ["nofill", "NoFill"]
    ];
    if (advMode == enumColorPickAdvMode.full)
      kFillRadioGroup = kFillRadioGroup.concat([
        ["dashline", "DashLine"],
        ["triangle", "Triangle"],
        ["lefttriangle", "LeftTriangle"],
        ["separator", "Separator"]
      ]);
    var rG = new QRadioButtonGroup();
    var radioIndex = 0;
    for (var idx = 0; idx < kFillRadioGroup.length; idx++) {
      var curRadioOpt = kFillRadioGroup[idx];
      if (curRadioOpt[1] === this.fCmdCode) {
        radioIndex = idx;
        break;
      }
    }

    rG.InitRadioButtonGroup(kFillRadioGroup, indent, yPos, this, radioIndex, false, true);
    this.fRadioGroup = rG;

    var yPos = rG.GetPositionY() + rG.GetHeight() + 4;
    var indent2 = indent + 16;
    var showColorPickers =
      startFillMode == enumFillMode.triangle ||
      startFillMode == enumFillMode.linearGradientDown ||
      startFillMode == enumFillMode.lefttriangle;

    this.fColor1Selector = this.AddColorButton(indent2, yPos, "TriColor1", startColor, null, false);
    this.fColor1Selector.SetShownState(showColorPickers);
    var col2 = this.fColor1Selector.GetWidth() + 8;
    this.fColor2Selector = this.AddColorButton(
      indent2 + col2,
      yPos,
      "TriColor2",
      startColor2,
      null,
      false
    );
    this.fColor2Selector.SetShownState(showColorPickers);

    var yPos = theHeight - 30;
    var buttonHeight = 20;
    var buttonMargin = indent;
    var butWidth = 50;

    var xRight = theWidth - buttonMargin;
    var okBut = AddStdButtonAutoPos(
      this,
      null,
      xRight,
      "right",
      butWidth,
      yPos,
      buttonHeight,
      appstr("OK"),
      null,
      null,
      false,
      "OKAdv"
    );
    okBut.SetCmdShortCut(kEnterOKShortCut, enumShortCutModKeys.none, "");
    okBut.SetEnabled(startFillMode != null);
    this.fOKBut = okBut;

    xRight = okBut.GetPositionX() - buttonMargin;
    AddStdButtonAutoPos(
      this,
      null,
      xRight,
      "right",
      butWidth,
      yPos,
      buttonHeight,
      appstr("Cancel"),
      null,
      null,
      false,
      "CancelAdv"
    );
  }

  DoCustomResize() {
    this.fWSMgr.RemovePanel(this);
  }

  BecomeKeyboardTarget() {
    var wsMgr = this.fWSMgr;
    wsMgr.SetKeyboardTarget(null, this, enumKeyboardTargetEnterAction.noAction);
  }

  SetColor1(selectedColor) {
    this.fNewColor = selectedColor;
    this.fColor1Selector.SetFillColor(selectedColor);
  }

  SetColor2(selectedColor) {
    this.fNewColor2 = selectedColor;
    this.fColor2Selector.SetFillColor(selectedColor);
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var wsMgr = aCmd.GetWSMgr();
    var panelHandled = true;
    var rIndex = -1;
    var xPos = aCmd["xPos"];
    var yPos = aCmd["yPos"];

    switch (cmdCode) {
      case "TriColor1":
        TPostColorPicker(
          wsMgr,
          this,
          xPos,
          yPos,
          "TriColor1S",
          false,
          true,
          this.fStartColor,
          aCmd
        );
        break;
      case "TriColor2":
        TPostColorPicker(
          wsMgr,
          this,
          xPos,
          yPos,
          "TriColor2S",
          false,
          true,
          this.fStartColor2,
          aCmd
        );
        break;
      case "Separator":
        rIndex = 6;
        break;
      case "Triangle":
        rIndex = 4;
        break;
      case "LeftTriangle":
        rIndex = 5;
        break;
      case "DashLine":
        rIndex = 3;
        break;
      case "SolidFill":
        rIndex = 0;
        break;
      case "NoFill":
        rIndex = 2;
        break;
      case "GradientFill":
        rIndex = 1;
        break;
      case "OKAdv":
        var cCode = this.fBaseCmd + "-" + this.fCmdCode; //"CellFillColor-"
        aCmd.ChangeCmdCode(cCode);
        wsMgr.RemovePanel(this);
        aCmd["newColor"] = this.fNewColor;
        aCmd["newColor2"] = this.fNewColor2;
        if (this.fSrcPicker) this.fSrcPicker.ExecuteCommand(aCmd);
        break;
      case "CancelAdv":
      case "CNCL":
        wsMgr.RemovePanel(this);
        break;
      default:
        panelHandled = false;
        break;
    }

    if (rIndex != -1) {
      this.fOKBut.SetEnabled(true);
      this.fCmdCode = cmdCode;
      this.fRadioGroup.SelectRadioButtonByIndex(rIndex);
      var shownColorPickers = rIndex == 4 || rIndex == 1 || rIndex == 5;
      this.fColor1Selector.SetShownState(shownColorPickers);
      this.fColor2Selector.SetShownState(shownColorPickers);
    }

    return panelHandled;
  }
}
